var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJcb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36.36 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -548.37,
    y1: 417.48,
    x2: -547.95,
    y2: 417.48,
    gradientTransform: "matrix(24.25, 0, 0, -15.02, 13324.6, 6286.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#00873f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#40a737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5cb531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -559.07,
    y1: 436.69,
    x2: -558.93,
    y2: 436.69,
    gradientTransform: "matrix(70.26, 0, 0, -170.72, 39303.96, 74564.8)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -546.84,
    y1: 414.13,
    x2: -546.39,
    y2: 414.13,
    gradientTransform: "matrix(22.22, 0, 0, -13.77, 12175.23, 5715)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -557.14,
    y1: 436.69,
    x2: -557,
    y2: 436.69,
    gradientTransform: "matrix(70.26, 0, 0, -170.56, 39146.55, 74496.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f286f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#004e94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#0066b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006fbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -558.11,
    y1: 436.69,
    x2: -557.97,
    y2: 436.69,
    gradientTransform: "matrix(70.26, 0, 0, -170.88, 39225.41, 74633.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c2c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#be1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#dc0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60039"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.36,22.36A5.65,5.65,0,0,1,30.71,28H0V5.64A5.65,5.65,0,0,1,5.64,0H36.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.36,16.62h2.33l.29,0a1,1,0,0,0,.82-1A1.08,1.08,0,0,0,29,14.51a1.32,1.32,0,0,0-.29,0H26.36Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.42,1.89a4,4,0,0,0-4,4v4.2h5.71a1.71,1.71,0,0,1,.4,0c1.29.06,2.24.73,2.24,1.88a1.89,1.89,0,0,1-1.84,1.85v0c1.31.09,2.31.83,2.31,2s-1.11,2-2.58,2H24.36v8.22h5.93a4,4,0,0,0,4-4V1.89Z",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.51,12.31a.94.94,0,0,0-.82-1l-.22,0H26.36v2h2.11a.68.68,0,0,0,.22,0,1,1,0,0,0,.82-1Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07,1.89A4,4,0,0,0,2,5.93v10a8,8,0,0,0,3.49.91,1.94,1.94,0,0,0,2.16-2V10.11h3.46V14.8c0,1.82-1.13,3.31-5,3.31A17.09,17.09,0,0,1,2,17.6v8.51H7.93a4,4,0,0,0,4.05-4V1.89Z",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.24,1.89a4,4,0,0,0-4,4v5.29c1-.86,2.8-1.42,5.67-1.29a18.24,18.24,0,0,1,3.17.49v1.71A7.73,7.73,0,0,0,19,11.24c-2.18-.15-3.49.92-3.49,2.78S16.8,17,19,16.8A8.08,8.08,0,0,0,22,15.91v1.71a17.84,17.84,0,0,1-3.17.49c-2.87.13-4.65-.42-5.67-1.29v9.34h5.93a4,4,0,0,0,4.05-4.05V1.89Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/jcb.9034cad6.svg";
export { ForwardRef as ReactComponent };